import { PageTitle } from "Components/Titles";
import { Container } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { ListSurveys } from "Features/Survey";

function ClearingList () {

    const { t } = useTranslation();

    return (
        <Container className="page">
            <PageTitle
                title={t("pages.clearings")}
            />
            <ListSurveys surveyRef="clearing" />
        </Container>
    );
}

export default ClearingList;